import React, { Suspense } from "react";
import { MsalProvider } from "@azure/msal-react";
import ClientDashboard from "./pages/ClientDashboard";
import routes from "./routes/route";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastProvider } from "./contexts/ToastContext";
import { AIConversationProvider } from "./contexts/AIConversationContext";
import { AssessmentAIProvider } from "./contexts/AssessmentAIContext";

function App({ instance }) {

  return (
    <MsalProvider instance={instance}>
      <ToastProvider>
        <AssessmentAIProvider>
          <AIConversationProvider>
            <Router>
              <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                {routes.map((route) => {
                  if (route.children) {
                    if (route.layout === true) {
                      return (
                        <Route
                          key={"layout-" + route.path}
                          element={<ClientDashboard title={route.title} />}
                        >
                          <Route
                            key={route.path}
                            path={route.path}
                            element={route.element}
                          >
                            {route.children.map((child) =>
                              child.index ? (
                                <Route
                                  key={"index-" + route.path}
                                  index
                                  element={child.element}
                                />
                              ) : (
                                <Route
                                  key={child.path}
                                  path={child.path}
                                  element={child.element}
                                />
                              )
                            )}
                          </Route>
                        </Route>
                      );
                    }

                    return (
                      <Route
                        key={route.path}
                        path={route.path}
                        element={route.element}
                      >
                        {route.children.map((child) =>
                          child.index ? (
                            <Route
                              key={"index-" + route.path}
                              index
                              element={child.element}
                            />
                          ) : (
                            <Route
                              key={child.path}
                              path={child.path}
                              element={child.element}
                            />
                          )
                        )}
                      </Route>
                    );
                  }

                  if (route.layout === true) {
                    return (
                      <Route
                        key={"layout-" + route.path}
                        element={<ClientDashboard title={route.title} />}
                      >
                        <Route
                          key={route.path}
                          path={route.path}
                          element={route.element}
                        />
                      </Route>
                    );
                  }

                  return (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={route.element}
                    />
                  );
                })}
                </Routes>
              </Suspense>
            </Router>
          </AIConversationProvider>
        </AssessmentAIProvider>
      </ToastProvider>
    </MsalProvider>
  );
}

export default App;
